module.exports = {"pathContext":{"name":"SortDirection","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ASC"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DESC"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-sort-direction.json
// module id = 1310
// module chunks = 76456355969304